var _effectorFileName = "/builds/gmini/front-chm-api-sdk/src/checklistManagerConnect.ts";
import "core-js/modules/es.array.concat.js";
import { buildRequestParams } from '@gmini/utils';

// eslint-disable-next-line import/no-cycle
import * as api from './index';
export function checklistManagerConnect(fetchService) {
  api.Template.fetchList.use(function (params) {
    return fetchService.get("/v1/template?".concat(buildRequestParams(params))).then(api.Template.fetchList.toPromise);
  });
  api.Template.fetchTemplate.use(function (_ref) {
    var id = _ref.id,
      version = _ref.version;
    return fetchService.get("/v1/template/".concat(id, "/version/").concat(version)).then(api.Template.fetchTemplate.toPromise);
  });
  api.Template.fetchTemplateMostRecent.use(function (_ref2) {
    var id = _ref2.id;
    return fetchService.get("/v1/template/".concat(id, "/most-recent")).then(api.Template.fetchTemplateMostRecent.toPromise);
  });
  api.Template.createTemplate.use(function (template) {
    return fetchService.post("/v1/template", template).then(api.Template.createTemplate.toPromise);
  });
  api.Template.deleteTemplate.use(function (_ref3) {
    var id = _ref3.id,
      version = _ref3.version;
    return fetchService["delete"]("/v1/template/".concat(id, "/version/").concat(version)).then(api.Template.deleteTemplate.toPromise);
  });
  api.Template.fetchTypes.use(function () {
    return fetchService.get("/v1/template/type").then(api.Template.fetchTypes.toPromise);
  });
  api.Template.updateTemplate.use(function (params) {
    return fetchService.patch("/v1/template/".concat(params.id, "/version/").concat(params.version), params).then(api.Template.updateTemplate.toPromise);
  });
  api.Template.createSection.use(function (_ref4) {
    var templateId = _ref4.templateId,
      templateVersion = _ref4.templateVersion,
      section = _ref4.section;
    return fetchService.post("/v1/template/".concat(templateId, "/version/").concat(templateVersion, "/section"), section).then(api.Template.createSection.toPromise);
  });
  api.Template.deleteSection.use(function (_ref5) {
    var templateId = _ref5.templateId,
      templateVersion = _ref5.templateVersion,
      sectionId = _ref5.sectionId;
    return fetchService["delete"]("/v1/template/".concat(templateId, "/version/").concat(templateVersion, "/section/").concat(sectionId)).then(api.Template.deleteSection.toPromise);
  });
  api.Template.updateSection.use(function (_ref6) {
    var templateId = _ref6.templateId,
      templateVersion = _ref6.templateVersion,
      sectionId = _ref6.sectionId,
      section = _ref6.section;
    return fetchService.patch("/v1/template/".concat(templateId, "/version/").concat(templateVersion, "/section/").concat(sectionId), section).then(api.Template.updateSection.toPromise);
  });
  api.Template.createQuestion.use(function (_ref7) {
    var templateId = _ref7.templateId,
      templateVersion = _ref7.templateVersion,
      question = _ref7.question,
      sectionId = _ref7.sectionId;
    return fetchService.post("/v1/template/".concat(templateId, "/version/").concat(templateVersion, "/section/").concat(sectionId, "/item"), question).then(api.Template.createQuestion.toPromise);
  });
  api.Template.deleteQuestion.use(function (_ref8) {
    var templateId = _ref8.templateId,
      templateVersion = _ref8.templateVersion,
      sectionId = _ref8.sectionId,
      questionId = _ref8.questionId;
    return fetchService["delete"]("/v1/template/".concat(templateId, "/version/").concat(templateVersion, "/section/").concat(sectionId, "/item/").concat(questionId)).then(api.Template.deleteQuestion.toPromise);
  });
  api.Template.updateQuestion.use(function (_ref9) {
    var templateId = _ref9.templateId,
      templateVersion = _ref9.templateVersion,
      sectionId = _ref9.sectionId,
      question = _ref9.question,
      questionId = _ref9.questionId;
    return fetchService.patch("/v1/template/".concat(templateId, "/version/").concat(templateVersion, "/section/").concat(sectionId, "/item/").concat(questionId), question).then(api.Template.updateQuestion.toPromise);
  });
  api.Instance.fetchList.use(function (params) {
    return fetchService.get("/v1/instance?".concat(buildRequestParams(params))).then(api.Instance.fetchList.toPromise);
  });
  api.Instance.fetch.use(function (_ref10) {
    var id = _ref10.id,
      version = _ref10.version;
    return fetchService.get("/v1/instance/".concat(id, "/version/").concat(version)).then(api.Instance.fetch.toPromise);
  });
  api.Instance.fetchMostRecent.use(function (_ref11) {
    var id = _ref11.id;
    return fetchService.get("/v1/instance/".concat(id, "/most-recent")).then(api.Instance.fetchMostRecent.toPromise);
  });
  api.Instance.create.use(function (instance) {
    return fetchService.post("/v1/instance", instance).then(api.Instance.create.toPromise);
  });
  api.Instance.update.use(function (params) {
    return fetchService.patch("/v1/instance/".concat(params.id, "/version/").concat(params.version), params).then(api.Instance.update.toPromise);
  });
  api.Instance.closeStatus.use(function (params) {
    return fetchService.post("/v1/instance/".concat(params.id, "/version/").concat(params.version, "/close-status"), {}).then(api.Instance.closeStatus.toPromise);
  });
  api.Instance.updateAnswer.use(function (params) {
    return fetchService.patch("/v1/instance/".concat(params.id, "/version/").concat(params.version, "/section-item-property/").concat(params.templateSectionItemId), {
      answer: params.answer
    }).then(api.Instance.updateAnswer.toPromise);
  });
  api.Instance.remove.use(function (_ref12) {
    var id = _ref12.id,
      version = _ref12.version;
    return fetchService["delete"]("/v1/instance/".concat(id, "/version/").concat(version)).then(api.Instance.remove.toPromise);
  });
  api.User.fetchUserList.use(function (params) {
    return fetchService.post("/v1/user", params).then(api.User.fetchUserList.toPromise);
  });
  api.Instance.uploadSectionItemFile.use(function (_ref13) {
    var formData = _ref13.formData,
      instanceId = _ref13.instanceId,
      instanceVersion = _ref13.instanceVersion,
      templateSectionItemId = _ref13.templateSectionItemId;
    return fetchService.uploadFile("/v1/instance/".concat(instanceId, "/version/").concat(instanceVersion, "/section-item-property/").concat(templateSectionItemId, "/file"), formData).then(api.Instance.uploadSectionItemFile.toPromise);
  });
  api.Instance.startUploadSectionItemFile.use(function (_ref14) {
    var instanceId = _ref14.instanceId,
      instanceVersion = _ref14.instanceVersion,
      templateSectionItemId = _ref14.templateSectionItemId;
    return fetchService.post("/v1/instance/".concat(instanceId, "/version/").concat(instanceVersion, "/section-item-property/").concat(templateSectionItemId, "/file/start-upload"), {}).then(api.Instance.startUploadSectionItemFile.toPromise);
  });
  api.Instance.deleteSectionItemFile.use(function (_ref15) {
    var fileId = _ref15.fileId,
      instanceId = _ref15.instanceId,
      instanceVersion = _ref15.instanceVersion;
    return fetchService["delete"]("/v1/instance/".concat(instanceId, "/version/").concat(instanceVersion, "/file/").concat(fileId)).then(api.Instance.deleteSectionItemFile.toPromise);
  });
  api.Instance.downloadSectionItemFile.use(function (_ref16) {
    var fileId = _ref16.fileId;
    return fetchService.get("/v1/instance/file/".concat(fileId)).then(api.Instance.downloadSectionItemFile.toPromise);
  });
  api.Instance.fetchSectionItemFileList.use(function (_ref17) {
    var instanceId = _ref17.instanceId,
      instanceVersion = _ref17.instanceVersion,
      templateSectionItemId = _ref17.templateSectionItemId;
    return fetchService.get("/v1/instance/".concat(instanceId, "/version/").concat(instanceVersion, "/section-item-property/").concat(templateSectionItemId, "/file")).then(api.Instance.fetchSectionItemFileList.toPromise);
  });
  api.InstanceStatus.fetchList.use(function () {
    return fetchService.get("/v1/instance/status").then(api.InstanceStatus.fetchList.toPromise);
  });
  api.Instance.fetchAllowedFilters.use(function (params) {
    return fetchService.get("/v1/instance/filter?".concat(buildRequestParams(params))).then(api.Instance.fetchAllowedFilters.toPromise);
  });
  api.Template.fetchAllowedFilters.use(function (params) {
    return fetchService.get("/v1/template/filter?".concat(buildRequestParams(params))).then(api.Template.fetchAllowedFilters.toPromise);
  });
}